var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container"},[_c('MetaTitle',{attrs:{"page-route":_vm.pageRoute}}),_vm._v(" "),_c('CatalogHeader',{attrs:{"pageroute":_vm.pageRoute}}),_vm._v(" "),_c('Catalog',{attrs:{"pageroute":_vm.pageRoute}}),_vm._v(" "),_c('CatalogFooter',{attrs:{"pageroute":_vm.pageRoute}}),_vm._v(" "),_c('Breadcrumb')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }